module.exports = __webpack_public_path__ + "static/img/notice-logo.3e24248a.svg";